// extracted by mini-css-extract-plugin
export default {"page_container":"daily_page_container__TwJIb","summary_box":"daily_summary_box__8h8Jr","header_box":"daily_header_box__CJPbR","header":"daily_header__8Pxsr"};